module.exports = __webpack_public_path__ + "media/frontend/svg/artists3-f6eaf71688b834d035593f35e546f6fb.svg";